import React from 'react';
import styled from 'styled-components';
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom';
import Modal from 'react-modal';
import { useState, useEffect  } from 'react';
import PolocyPopup, { PolocyPopupModalStyles } from './popup/PolocyPopup';
import PrivacyPopup from './popup/PrivacyPopup';
import IconBtn from './button/IconBtn';
import CustomImg from './image/CustomImg';
import { useSelector } from 'react-redux';
import {isMobileOnly} from 'react-device-detect';
import $ from 'jquery';

const FooterBlock = styled.div`
    display: ${props => props.display};
    
    .sz-wrap {
      display: flex;
      justify-content: space-between;
      flex-flow: row wrap;
    }
    
    .f-faq {
      margin-bottom:${isMobileOnly?'1rem':'0'};
    }
    
    .f-mindgroup {
      display: flex;
      div:nth-child(1) {margin-right:66px;}
      ${!isMobileOnly&&"margin-left: auto"};
    }
    
    #siteMoveBtn {
      bottom: ${props=>props.btnPosition};
      ${isMobileOnly?`
        width: 48px;
        height: 48px;
        background: url(/assets/images/icon/sitemove-icon-mobile.png) center center/cover
        no-repeat;
        border-radius: 10px;
        z-index: 1;
        background-size: 72px 72px;
        margin-right: 2vw;
      `:`
        width: 96px;
        height: 96px;
        z-index: 100;
      `};
      
    }
`;

const FooterSnsBlock = styled.ul`

    position: absolute;
    top: 0;
    right: ${isMobileOnly?'1rem':'0'};;

`;

const FooterFaqLinkBlock = styled.div`
    cursor : pointer
`;


const Footer = ({ usePopUp = false, evHandler = null, siteMovePosition = "10px" }) => {
    const history = useHistory();

    const [openModal, setOpenModal] = useState(false);
    const [kindModal, setKindModal] = useState(0);

    var { curMenu } = useSelector(
        ({ headerReducer }) => ({
            curMenu: headerReducer.curMenu,
        })
    );

    //#2611 top 버튼 처리
    useEffect(() => {
        const onScroll = () => {
            var nowScroll = $(window).scrollTop();

            var $moveBtn = $('#siteMoveBtn');
            if($moveBtn.length){
                if ( nowScroll < 350 ) {
                    $moveBtn.fadeOut();
                } else {
                    $moveBtn.fadeIn();
                }
            }

        };

        var $moveBtn = $('#siteMoveBtn');
        if($moveBtn.length){
            $moveBtn.fadeOut();
        }

        // scroll 이벤트를 만들어줍니다. 스크롤을 움직일때 마다
        // onScroll 함수가 실행됩니다.
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const iconSize = () =>{return isMobileOnly?'30px':'44px';};
    const iconMargin = () => {return isMobileOnly?'5px':'16px';};

    const getGray = () => {
        if (history.location.pathname.includes('login') || history.location.pathname.includes('register') || history.location.pathname.includes('resetpw') || history.location.pathname.includes('findid')) {
            return true;
        }

        return false;
    }

    // Modal 열기
    const onOpenModal = () => {
        setOpenModal(true);
    }

    // Modal 닫기
    const onCloseModal = () => {
        setKindModal(0);
        setOpenModal(false);
    }

    const getPopupComp = () => {

        if (kindModal === 0) {
            return <PolocyPopup onClickIcon={onCloseModal} />
        } else {
            return <PrivacyPopup onClickIcon={onCloseModal} />
        }
    }

    const handleIconClick = () => {

    }

    //history.push('/prod?prodid=' + prodinfo._source.prdct_id)

    const handleFaqLink = (link) => {

        if (curMenu === "faq") {
            if (evHandler !== null) {
                evHandler(link);
            }
        }
        else {
            history.push("/faq",{ link: link });
        }
    }

    //#2611 top 버튼 처리
    const handleTopClick = () => {
        //window.scrollTo({ top: 200, behavior: 'smooth' });
        $('html, body').stop().animate({
            scrollTop: 0
        }, 500, 'swing');


    }

    const upperFooterStyle = () =>{
      let style =   getGray() ? { backgroundColor: '#f4f4f4' } : { backgroundColor: 'transparent', borderTop: '1px solid #e7e7e7' };
      if(isMobileOnly){
          style['padding'] = "0 0.5rem";
      }
      return style;
    };

    return (
        <FooterBlock display={usePopUp ? 'none' : ''} btnPosition={siteMovePosition}>
            <footer id="footer">
                <div className="f-top"
                    style={upperFooterStyle()}>
                    <div className="sz-wrap clearfix" style={!isMobileOnly?{width:'1176px'}:{padding: '1rem'}}>
                        <div className="f-faq">
                            <h2 className="f-list_title">자주 찾는 질문</h2>
                            <ol className="f-list">
                                <li><FooterFaqLinkBlock onClick={() => handleFaqLink("faq_type=125101&id=97")}><span className="font-mont">1.</span> 견적이란 무엇인가요?</FooterFaqLinkBlock></li>
                                <li><FooterFaqLinkBlock onClick={() => handleFaqLink("faq_type=125101&id=10")}><span className="font-mont">2.</span> 요청서와 견적서의 차이를 알고 싶어요!</FooterFaqLinkBlock></li>
                                <li><FooterFaqLinkBlock onClick={() => handleFaqLink("faq_type=125101&id=11")}><span className="font-mont">3.</span> 비회원도 견적을 요청할 수 있나요?</FooterFaqLinkBlock></li>
                                <li><FooterFaqLinkBlock onClick={() => handleFaqLink("faq_type=125102&id=13")}><span className="font-mont">4.</span> 주문내역은 어디에서 확인하나요?</FooterFaqLinkBlock></li>
                                <li><FooterFaqLinkBlock onClick={() => handleFaqLink("faq_type=125101&id=1")}><span className="font-mont">5.</span> 견적서를 받기까지 시간이 얼마나 걸리나요?</FooterFaqLinkBlock></li>
                            </ol>
                        </div>

                        <div className="f-mindgroup">
                            <div>
                                <h2 className="f-list_title"><span className="font-mont">ABOUT US</span></h2>
                                <ul className="f-list">
                                    <li><a href="http://www.mindgroup.co.kr/odgagu" target='_blank'>회사소개</a></li>
                                    <li style={{ cursor: 'pointer' }} onClick={() => { setKindModal(0); setOpenModal(true) }}>이용약관</li>
                                    <li style={{ cursor: 'pointer' }} onClick={() => { setKindModal(1); setOpenModal(true) }}>개인정보 취급방침</li>
                                </ul>
                            </div>
                            <div>
                                <h2 className="f-list_title"><span className="font-mont">HELP</span></h2>
                                <ul className="f-list">
                                    <li><Link to="/notice">공지사항</Link></li>
                                    <li><Link to="/faq">자주찾는 질문</Link></li>
                                    <li><Link to="/consult">1:1문의</Link></li>
                                    <li><a href="https://partner.odgagu.co.kr/entry/request" target="_blank">입점 문의</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="f-btm">
                    <div className="sz-wrap clearfix" style={isMobileOnly?{padding:'0px 1rem'}:{width:'1176px'}}>
                        <p>
                            <span className="f-number font-mont">02-6713-6420</span>
                            <span className="f-text">
                                평일 <span className="font-mont">10:00-18:00</span>
                                    (점심시간 <span className="font-mont">12:00 ~13:00</span> 주말<span className="font-mont">&</span>공휴일 제외)
                                </span>
                        </p>
                        <p className="f-info">
                            어디가구는 통신판매중개자로서 통신판매의 당사자가 아닙니다. 개별 판매자가 등록하여 판매한 모든 상품에 대한 거래 정보 및 거래에 대한 책임은 각 판매자가 부담하고, 이에 대하여 어디가구는 일체 책임지지 않습니다.
                        </p>
                        <p className="f-info">
                            상호명 : (주)마인드그룹 &nbsp; 이메일 : <span className="font-mont">cs@odgagu.co.kr</span> &nbsp; 대표 : 유수종
                            &nbsp; 사업자등록번호 : <span className="font-mont">262-86-00484</span> &nbsp;
                                통신판매업신고번호 : 제<span className="font-mont">2019</span>-서울서초-<span className="font-mont">1845</span>호
                                <br />
                                주소 : 서울특별시 서초구 신반포로 <span className="font-mont">339</span>
                                논현빌딩 <span className="font-mont">B-16</span> &nbsp;&nbsp; <span className="font-mont">Copyright © 2020 Mindgroup Co., Ltd. All rights reserved.</span>
                        </p>

                        <FooterSnsBlock>
                            <Link to="//www.instagram.com/odgagu" target="_blank">
                                <IconBtn height={iconSize()} width={iconSize()} marginRight={iconMargin()}
                                    img={"/assets/images/icon/sns_insta.png"} />
                            </Link>
                            <Link to="//m.post.naver.com/mindgrmkt" target="_blank">
                                <IconBtn height={iconSize()} width={iconSize()} marginRight={iconMargin()}
                                    img={"/assets/images/icon/sns_npost.png"} />
                            </Link>
                            <Link to="//www.youtube.com/channel/UCkQoH9cRNj4NaoG9T5nQeRw" target="_blank">
                                <IconBtn height={iconSize()} width={iconSize()} marginRight="0px"
                                    img={"/assets/images/icon/sns_youtube.png"} />
                            </Link>
                        </FooterSnsBlock>
                    </div>
                </div>

                <div id="siteMoveBtn" style={{display: "none"}}>
                    <button type="button" className="top" onClick={handleTopClick}></button>
                </div>
            </footer>

            <Modal
                isOpen={openModal}
                onRequestClose={onCloseModal}
                style={PolocyPopupModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getPopupComp()}
            </Modal>

        </FooterBlock>
    );
};

export default Footer;
